import React from 'react';
import { Link } from 'react-router-dom';
import { useWhatsApp } from '../hooks/useWhatsApp';
import { COMPANY } from '../constants';
import styles from './Footer.module.css';

const GearIcon = () => (
  <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="4" fill="#1c2126" stroke="#f5c518" strokeWidth="2"/>
    <path d="M16 2v4M16 26v4M2 16h4M26 16h4M6.34 6.34l2.83 2.83M22.83 22.83l2.83 2.83M6.34 25.66l2.83-2.83M22.83 9.17l2.83-2.83" stroke="#f5c518" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="16" cy="16" r="7" stroke="#f5c518" strokeWidth="1.5" strokeDasharray="3 2"/>
  </svg>
);

export default function Footer() {
  const { openGeneral } = useWhatsApp();
  return (
    <footer className={styles.footer}>
      <div className={styles.topStripe} />
      <div className="container">
        <div className={styles.grid}>
          {/* Brand */}
          <div className={styles.brand}>
            <div className={styles.logoRow}>
              <GearIcon />
              <div className={styles.logoText}>
                <span className={styles.logoName}>BRIGHT</span>
                <span className={styles.logoSub}>MACHINERIES</span>
              </div>
            </div>
            <p className={styles.brandDesc}>
              Used metal working machine seller based in Navi Mumbai. Physically verified stock, fair pricing, ready to inspect.
            </p>
            <button className={styles.waBtn} onClick={openGeneral}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp Enquiry
            </button>
          </div>

          {/* Links */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Quick Links</h4>
            <nav className={styles.links}>
              <Link to="/" className={styles.link}>Home</Link>
              <Link to="/stock" className={styles.link}>Browse Stock</Link>
              <Link to="/about" className={styles.link}>About Us</Link>
              <Link to="/contact" className={styles.link}>Contact Us</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Contact</h4>
            <div className={styles.contacts}>
              <a href={`tel:${COMPANY.phone}`} className={styles.contactItem}>
                📞 {COMPANY.phone}
              </a>
              <a href={`mailto:${COMPANY.email}`} className={styles.contactItem}>
                ✉️ {COMPANY.email}
              </a>
              <div className={styles.contactItem}>
                📍 {COMPANY.address}
              </div>
              <div className={styles.contactItem}>
                🕐 {COMPANY.hours}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.bottom}>
          <span>© {new Date().getFullYear()} Bright Machineries. All rights reserved.</span>
          <span className={styles.maintained}>
            Maintained By <a className={styles.maintainedLink} href="https://www.crazygeeks.in" target="_blank" rel="noreferrer">Crazy Geeks</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
